import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.accounts');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-accounts',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.accounts/view.scss */
:host {
  display: block;
}

.accounts-page {
  max-width: 1180px;
  margin: 0 auto;
}

.page-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
}

.eyebrow {
  margin: 0 0 8px;
  color: var(--kiom-primary);
  font-size: 10px;
  font-weight: 850;
  letter-spacing: 0.12em;
}

.page-heading h1 {
  margin: 0;
  color: var(--kiom-ink);
  font-size: 27px;
  letter-spacing: -0.035em;
}

.page-heading p:not(.eyebrow) {
  margin: 8px 0 0;
  color: var(--kiom-muted);
  font-size: 11px;
}

.refresh-button {
  height: 36px;
  padding: 0 14px;
  border: 1px solid var(--kiom-border);
  border-radius: 9px;
  color: #45645f;
  background: #fff;
  font-size: 10px;
  font-weight: 700;
}

.summary-strip {
  display: grid;
  align-items: center;
  margin-top: 26px;
  padding: 18px 22px;
  border: 1px solid var(--kiom-border);
  border-radius: 14px;
  background: #fff;
  grid-template-columns: 130px 130px 1fr;
  box-shadow: 0 8px 28px rgba(25, 61, 52, 0.05);
}

.summary-strip div {
  border-right: 1px solid var(--kiom-border);
}

.summary-strip span,
.summary-strip strong {
  display: block;
}

.summary-strip span {
  color: var(--kiom-muted);
  font-size: 9px;
}

.summary-strip strong {
  margin-top: 3px;
  font-size: 22px;
}

.summary-strip p {
  margin: 0;
  color: #74847f;
  font-size: 10px;
  text-align: right;
}

.state-card {
  margin-top: 20px;
  padding: 54px;
  border: 1px solid var(--kiom-border);
  border-radius: 16px;
  color: var(--kiom-muted);
  background: #fff;
  font-size: 11px;
  text-align: center;
}

.state-card.empty span {
  width: 42px;
  height: 42px;
  display: grid;
  margin: 0 auto 12px;
  place-items: center;
  border-radius: 50%;
  color: var(--kiom-primary);
  background: var(--kiom-primary-soft);
  font-weight: 800;
}

.state-card.empty strong {
  display: block;
  color: var(--kiom-ink);
}

.state-card.empty p {
  margin: 6px 0 0;
  font-size: 10px;
}

.account-list {
  display: grid;
  margin-top: 20px;
  gap: 12px;
}

.account-card {
  display: grid;
  align-items: center;
  padding: 18px;
  border: 1px solid var(--kiom-border);
  border-radius: 15px;
  background: #fff;
  grid-template-columns: minmax(220px, 1fr) minmax(340px, 1.35fr) minmax(300px, 1.2fr);
  gap: 18px;
}

.account-identity {
  display: flex;
  align-items: center;
  gap: 12px;
}

.avatar {
  width: 42px;
  height: 42px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 12px;
  color: #fff;
  background: var(--kiom-primary);
  font-size: 12px;
  font-weight: 800;
}

.type-chip {
  display: inline-flex;
  padding: 3px 6px;
  border-radius: 5px;
  color: var(--kiom-primary);
  background: var(--kiom-primary-soft);
  font-size: 8px;
  font-weight: 800;
}

.type-chip.reviewer {
  color: var(--kiom-review);
  background: var(--kiom-review-soft);
}

.account-identity h2 {
  margin: 5px 0 0;
  font-size: 13px;
}

.account-identity p {
  margin: 2px 0 0;
  color: var(--kiom-muted);
  font-size: 9px;
}

.approval-fields {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 8px;
}

.approval-fields label > span {
  display: block;
  margin-bottom: 5px;
  color: #61716d;
  font-size: 8px;
  font-weight: 750;
}

.approval-fields select,
.account-actions input {
  width: 100%;
  height: 36px;
  padding: 0 10px;
  border: 1px solid #d6dfdc;
  border-radius: 8px;
  color: var(--kiom-ink);
  background: #fff;
  font-size: 9px;
}

.account-actions {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 7px;
}

.account-actions button {
  height: 36px;
  padding: 0 11px;
  border-radius: 8px;
  font-size: 9px;
  font-weight: 750;
}

.reject-button {
  border: 1px solid #e5caca;
  color: #a24848;
  background: #fff8f8;
}

.approve-button {
  border: 0;
  color: #fff;
  background: var(--kiom-primary);
}

.operation-note {
  display: flex;
  margin-top: 18px;
  padding: 14px 16px;
  border-radius: 11px;
  color: #576a65;
  background: #eaf3f0;
  font-size: 9px;
  line-height: 1.5;
  gap: 12px;
}

.operation-note strong {
  flex: 0 0 auto;
}

@media (max-width: 1150px) {
  .account-card {
    grid-template-columns: 1fr 1.4fr;
  }
  .account-actions {
    grid-column: 1/-1;
  }
}
@media (max-width: 720px) {
  .summary-strip {
    grid-template-columns: 1fr 1fr;
  }
  .summary-strip p {
    grid-column: 1/-1;
    margin-top: 14px;
    text-align: left;
  }
  .account-card,
  .approval-fields {
    grid-template-columns: 1fr;
  }
  .account-actions {
    grid-template-columns: 1fr 1fr;
  }
  .account-actions input {
    grid-column: 1/-1;
  }
}
/* Drive UI surface */
.accounts-page {
  max-width: 1540px;
  min-height: 620px;
  box-sizing: border-box;
  margin: 24px auto 36px;
  padding: 0 22px 22px;
  border: 1px solid #dfe6e3;
  border-radius: 16px;
  color: #22312c;
  background: #fff;
  box-shadow: 0 1px 2px rgba(30, 50, 43, 0.03);
}

.page-heading {
  min-height: 70px;
  align-items: center;
  margin: 0 -22px;
  padding: 0 22px;
  border-bottom: 1px solid #e7ecea;
}

.eyebrow {
  margin-bottom: 3px;
  color: #18845f;
  font-size: 11px;
  letter-spacing: 0.04em;
}

.page-heading h1 {
  color: #172f27;
  font-size: 20px;
}

.page-heading p:not(.eyebrow) {
  margin-top: 4px;
  color: #697a73;
  font-size: 12px;
}

.refresh-button {
  min-height: 36px;
  font-size: 11px;
}

.summary-strip {
  margin-top: 18px;
  padding: 16px 18px;
  border-color: #dfe6e3;
  border-radius: 11px;
  box-shadow: none;
}

.summary-strip span, .summary-strip p {
  font-size: 11px;
}

.summary-strip strong {
  color: #223a31;
}

.state-card {
  border-color: #dfe6e3;
  border-radius: 11px;
  font-size: 12px;
}

.state-card.empty p {
  font-size: 11px;
}

.account-card {
  border-color: #dfe6e3;
  border-radius: 11px;
}

.type-chip {
  font-size: 10px;
}

.account-identity h2 {
  font-size: 14px;
}

.account-identity p, .approval-fields label > span {
  font-size: 11px;
}

.approval-fields select, .account-actions input, .account-actions button {
  height: 38px;
  font-size: 12px;
}

.operation-note {
  font-size: 11px;
}

@media (max-width: 720px) {
  .accounts-page {
    margin: 14px;
    padding: 0 16px 18px;
  }
  .page-heading {
    margin: 0 -16px;
    padding: 14px 16px;
  }
}`],
})
export class PageAdminAccountsComponent implements OnInit {
    public loading: boolean = true;
    public accounts: any[] = [];
    public datasets: any[] = [];

    public researcherRoles: any[] = [
        { value: 'AUTHOR', label: '저작자' },
        { value: 'DATASET_ADMIN', label: '데이터셋 관리자' },
        { value: 'GENERATION_OPERATOR', label: 'QA 생성 운영자' },
        { value: 'REVIEWER', label: '내부 검수자' },
        { value: 'REVIEW_ADMIN', label: '검수 관리자' },
        { value: 'RELEASE_ADMIN', label: '데이터셋 관리자' }
    ];

    public reviewerRoles: any[] = [
        { value: 'REVIEWER', label: '한의사 검수자' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.check()) {
            this.service.href('/access');
            return;
        }
        if (this.service.auth.session.user_type !== 'SYSTEM_ADMIN') {
            this.service.href('/forbidden');
            return;
        }
        await this.load();
    }

    public rolesFor(account: any) {
        return account.user_type === 'MEDICAL_REVIEWER'
            ? this.reviewerRoles
            : this.researcherRoles;
    }

    private async showError(message: string) {
        await this.service.modal.show({
            title: '처리 실패',
            message: message,
            cancel: false,
            action: '확인',
            actionBtn: 'error',
            status: 'error'
        });
    }

    public async load() {
        this.loading = true;
        try {
            let datasets: any = await this.service.request.post('/api/datasets/list');
            let accounts: any = await this.service.request.post('/api/account/admin/pending');

            if (datasets.code !== 200 || accounts.code !== 200) {
                await this.showError(
                    (accounts.data && accounts.data.message)
                    || (datasets.data && datasets.data.message)
                    || '관리 데이터를 불러오지 못했습니다.'
                );
                return;
            }

            this.datasets = datasets.data.datasets || [];
            this.accounts = (accounts.data.accounts || []).map((account: any) => {
                account.dataset_id = this.datasets.length ? this.datasets[0].id : '';
                account.role = account.user_type === 'MEDICAL_REVIEWER' ? 'REVIEWER' : 'AUTHOR';
                account.reason = '';
                account.processing = false;
                return account;
            });
        } finally {
            this.loading = false;
        }
    }

    public async approve(account: any) {
        if (account.processing) return;
        if (!account.dataset_id) {
            await this.showError('역할을 배정할 활성 데이터셋이 없습니다.');
            return;
        }

        account.processing = true;
        try {
            let approval: any = await this.service.request.post('/api/account/admin/approve', {
                user_id: account.id
            });
            if (approval.code !== 200) {
                await this.showError(approval.data && approval.data.message ? approval.data.message : '계정 승인에 실패했습니다.');
                return;
            }

            let assignment: any = await this.service.request.post('/api/datasets/assign', {
                user_id: account.id,
                dataset_id: account.dataset_id,
                roles: account.role
            });
            if (assignment.code !== 200) {
                await this.showError(
                    '계정은 승인되었지만 역할 배정에 실패했습니다. 데이터셋 참여자 관리에서 다시 배정해 주세요. '
                    + (assignment.data && assignment.data.message ? assignment.data.message : '')
                );
                await this.load();
                return;
            }

            await this.service.modal.show({
                title: '승인 완료',
                message: account.name + ' 계정이 활성화되고 데이터셋 역할이 배정되었습니다.',
                cancel: false,
                action: '확인',
                actionBtn: 'success',
                status: 'success'
            });
            await this.load();
        } finally {
            account.processing = false;
        }
    }

    public async reject(account: any) {
        if (!account.reason || account.reason.trim().length < 2) {
            await this.showError('거절 사유를 2자 이상 입력해 주세요.');
            return;
        }
        let confirmed = await this.service.modal.show({
            title: '가입 요청 거절',
            message: account.name + ' 계정의 가입 요청을 거절하시겠습니까?',
            cancel: '취소',
            action: '거절',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;

        let result: any = await this.service.request.post('/api/account/admin/reject', {
            user_id: account.id,
            reason: account.reason
        });
        if (result.code !== 200) {
            await this.showError(result.data && result.data.message ? result.data.message : '거절 처리에 실패했습니다.');
            return;
        }
        await this.load();
    }
}

export default PageAdminAccountsComponent;